import { defineStore } from "pinia";
import type { DisplayPermission } from "~/core/models/DisplayPermission.enum";
import LxcError from "~/core/models/LxcError.class";
import { login } from "~/core/utils/auth.utils";
import type { UserSession } from "~/modules/user/models/UserSession.interface";
import userService from "~/modules/user/services/user.service";
import { setLocaleTag } from "~/plugins/i18n";

export const useUserSession = defineStore("userSession", () => {
  const userSession: Ref<UserSession | undefined> = ref();

  const isAuthenticated = ref(false);

  /**
   * Apply retrieve current user to store
   */
  async function setCurrentUser(): Promise<void> {
    const response = await userService.getCurrentUser();

    if (LxcError.check(response)) {
      login();
    } else {
      userSession.value = response;

      isAuthenticated.value =
        !!userSession.value?.login && userSession.value?.active;

      setLocaleTag(userSession.value.language);

      // Add the permissions of the user to entity for more convenience to restore permissions
      userSession.value.entity.permissions = userSession.value.permissions;
    }
  }

  function setCurrentUserPermissions(permissions: DisplayPermission[]) {
    if (userSession.value) {
      userSession.value.permissions = permissions;
    }
  }

  return {
    userSession,
    setCurrentUser,
    setCurrentUserPermissions,
    isAuthenticated,
  };
});
